import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import arrowleft from "../assets/images/arrow-left.png";
import DropdownRight from "./DropdownRight";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import ReactInputMask from "react-input-mask";
import { SpinnerCircular } from "spinners-react";

function EditAnalystProfile(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const { id, analyst: initialAnalyst } = location.state || {};
  const [analyst, setAnalyst] = useState(initialAnalyst || {});
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const token = GetStorage.get("xAuthToken");

  const analystId = id || initialAnalyst?.id;

  useEffect(() => {
    if (analystId && (!initialAnalyst || !initialAnalyst.firstname)) {
      getAnalystDetails();
    }
  }, [analystId]);

  const getAnalystDetails = () => {
    setLoading(true);
    http
      .get(`api/admin/analyst/${analystId}?token=${token}`)
      .then((res) => {
        setLoading(false);
        if (res.data) {
          setAnalyst(res.data);
        }
      })
      .catch((error) => {
        http
          .get(`public/admin/analyst?token=${token}`)
          .then((res) => {
            setLoading(false);
            const foundAnalyst = res.data.find((item) => item.id === analystId);
            if (foundAnalyst) {
              setAnalyst(foundAnalyst);
            }
          })
          .catch((err) => {
            setLoading(false);
            console.log("error fetching analyst details", err);
          });
      });
  };

  const validate = (values) => {
    const errors = {};

    // First Name validation: mandatory, letters and allowed characters only, no numbers
    if (!values.firstname || !values.firstname.toString().trim()) {
      errors.firstname = "First Name is required.";
    } else if (!/^[A-Za-z\s'-]+$/.test(values.firstname.toString().trim())) {
      errors.firstname = "First Name must contain only letters.";
    }

    // Last Name validation: mandatory, letters and allowed characters only, no numbers
    if (!values.lastname || !values.lastname.toString().trim()) {
      errors.lastname = "Last Name is required.";
    } else if (!/^[A-Za-z\s'-]+$/.test(values.lastname.toString().trim())) {
      errors.lastname = "Last Name must contain only letters.";
    }

    // Email validation: mandatory, valid format
    if (!values.email || !values.email.toString().trim()) {
      errors.email = "Email Address is required.";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        values.email.toString().trim()
      )
    ) {
      errors.email = "Please enter a valid email address.";
    }

    // Phone validation: mandatory, must contain valid digits
    let cleanPhone = values.phone
      ? values.phone.toString().replace(/\(|\)|\s|-/g, "")
      : "";
    if (!cleanPhone || !cleanPhone.trim()) {
      errors.phone = "Phone Number is required.";
    } else if (cleanPhone.replace("+", "").length < 10) {
      errors.phone = "Please enter a valid 10-digit phone number.";
    }

    // Work Limit validation: mandatory, numbers only, min 1, max 1000
    const workLimitStr =
      values.work_limit !== undefined && values.work_limit !== null
        ? values.work_limit.toString().trim()
        : values.workLimit !== undefined && values.workLimit !== null
        ? values.workLimit.toString().trim()
        : "";
    if (workLimitStr === "") {
      errors.work_limit = "Work Limit is required.";
    } else if (!/^\d+$/.test(workLimitStr)) {
      errors.work_limit = "Work Limit must be a non-negative number.";
    } else {
      const num = Number(workLimitStr);
      if (num < 1 || num > 1000) {
        errors.work_limit = "Work Limit must be between 1 and 1000.";
      }
    }

    return errors;
  };

  const onSubmit = async (values) => {
    setUpdating(true);
    let formattedPhone = values.phone
      ? values.phone.toString().replace(/\(|\)|\s|-/g, "")
      : "";
    if (formattedPhone && !formattedPhone.startsWith("+")) {
      formattedPhone = "+" + formattedPhone;
    }

    const payload = {
      firstname: values.firstname,
      lastname: values.lastname,
      email: values.email,
      phone: formattedPhone,
      work_limit: values.work_limit,
    };

    http
      .put(`api/admin/analyst/update-profile/${analystId}?token=${token}`, payload)
      .then((res) => {
        showToast(
          "success",
          res.data.message || "Analyst profile details updated successfully!"
        );
        setUpdating(false);
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      })
      .catch((error) => {
        setUpdating(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);
          }
        } else {
          showToast("error", "Failed to update analyst profile.");
        }
      });
  };

  const initialValues = {
    firstname: analyst.firstname || "",
    lastname: analyst.lastname || "",
    email: analyst.email || "",
    phone: analyst.phone || "",
    work_limit:
      analyst.work_limit !== undefined && analyst.work_limit !== null
        ? analyst.work_limit
        : analyst.workLimit !== undefined && analyst.workLimit !== null
        ? analyst.workLimit
        : "",
  };

  const isFormDisabled = updating || loading;

  return (
    <>
      <body>
        <div className="wrapper">
          <Nav />
          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  <button
                    onClick={() => navigate(-1)}
                    type="button"
                    id="sidebarCollapse"
                    className="btn btn-link  "
                    disabled={isFormDisabled}
                  >
                    <img src={arrowleft} className="img-fluid" alt="back" />{" "}
                  </button>
                  <h1>Edit Analyst Profile</h1>{" "}
                </div>
                <DropdownRight />
              </div>
            </header>

            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              validate={validate}
              onSubmit={onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleSubmit,
                setFieldValue,
                handleChange,
                handleBlur,
              }) => (
                <>
                  <div className="dashbord_content">
                    <div className="dashobord_inner new_team_add">
                      <h5 className="my-3">General Info</h5>
                      <form onSubmit={handleSubmit} noValidate>
                        <div className="row">
                          <div className="col-md-4 col-sm-6 mb-3">
                            <div className="fomr-group">
                              <label>
                                First Name <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="firstname"
                                name="firstname"
                                placeholder="Enter First Name"
                                disabled={isFormDisabled}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (!/\d/.test(val)) {
                                    handleChange(e);
                                  }
                                }}
                                onBlur={handleBlur}
                                value={values.firstname}
                                className={`custom_input form-control ${
                                  touched.firstname && errors.firstname
                                    ? "is-invalid"
                                    : ""
                                }`}
                              />
                              {touched.firstname && errors.firstname && (
                                <span className="text-danger small mt-1 d-block">
                                  {errors.firstname}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6 mb-3">
                            <div className="fomr-group">
                              <label>
                                Last Name <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="lastname"
                                name="lastname"
                                placeholder="Enter Last Name"
                                disabled={isFormDisabled}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (!/\d/.test(val)) {
                                    handleChange(e);
                                  }
                                }}
                                onBlur={handleBlur}
                                value={values.lastname}
                                className={`custom_input form-control ${
                                  touched.lastname && errors.lastname
                                    ? "is-invalid"
                                    : ""
                                }`}
                              />
                              {touched.lastname && errors.lastname && (
                                <span className="text-danger small mt-1 d-block">
                                  {errors.lastname}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6 mb-3">
                            <div className="fomr-group">
                              <label>
                                Email Address <span className="text-danger">*</span>
                              </label>
                              <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Enter Email Address"
                                disabled={isFormDisabled}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                                className={`custom_input form-control ${
                                  touched.email && errors.email
                                    ? "is-invalid"
                                    : ""
                                }`}
                              />
                              {touched.email && errors.email && (
                                <span className="text-danger small mt-1 d-block">
                                  {errors.email}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6 mb-3">
                            <div className="fomr-group">
                              <label>
                                Phone Number <span className="text-danger">*</span>
                              </label>
                              <ReactInputMask
                                placeholder="+1 999-999-9999"
                                disabled={isFormDisabled}
                                className={`custom_input form-control ${
                                  touched.phone && errors.phone
                                    ? "is-invalid"
                                    : ""
                                }`}
                                id="phone"
                                name="phone"
                                mask={"+1 999-999-9999"}
                                onChange={(e) => {
                                  let phone = e.currentTarget.value.replace(
                                    /\(|\)|\s|-/g,
                                    ""
                                  );
                                  setFieldValue("phone", phone);
                                }}
                                onBlur={handleBlur}
                                value={values.phone}
                              />
                              {touched.phone && errors.phone && (
                                <span className="text-danger small mt-1 d-block">
                                  {errors.phone}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-md-4 col-sm-6 mb-3">
                            <div className="fomr-group">
                              <label>
                                Work Limit <span className="text-danger">*</span>
                              </label>
                              <input
                                type="number"
                                id="work_limit"
                                name="work_limit"
                                placeholder="Enter Work Limit (1-1000)"
                                min="1"
                                max="1000"
                                disabled={isFormDisabled}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val === "" || Number(val) >= 0) {
                                    setFieldValue("work_limit", val);
                                  }
                                }}
                                onBlur={handleBlur}
                                value={values.work_limit}
                                className={`custom_input form-control ${
                                  touched.work_limit && errors.work_limit
                                    ? "is-invalid"
                                    : ""
                                }`}
                              />
                              {touched.work_limit && errors.work_limit && (
                                <span className="text-danger small mt-1 d-block">
                                  {errors.work_limit}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-12 d-flex justify-content-end">
                            <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                              <button
                                onClick={() => navigate(-1)}
                                type="button"
                                className="them_btn_ouline"
                                disabled={isFormDisabled}
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                className="them_btn"
                                disabled={isFormDisabled}
                              >
                                {updating ? (
                                  <SpinnerCircular size={20} color="#ffffff" />
                                ) : (
                                  "Update"
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </div>
      </body>
      <ToastContainer />
    </>
  );
}

export default EditAnalystProfile;
